import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { resolveMedia } from "@/lib/api";

export default function Hero() {
  const { content } = useContent();
  const site = content.site || {};
  const assets = content.assets || {};
  const hero = content.hero || {};
  const labelLine = (hero.labelLine || "Mažoji architektūra · {city}").replace(
    "{city}",
    site.city || ""
  );
  const ctaP = hero.ctaPrimary || { label: "Peržiūrėti projektus", to: "/projektai" };
  const ctaS = hero.ctaSecondary || { label: "Susisiekti", to: "/kontaktai" };
  return (
    <section
      data-testid="hero-section"
      className="relative w-full min-h-[100svh] overflow-hidden bg-[#1a1a1a]"
    >
      <img
        src={resolveMedia(assets.hero)}
        alt="Karkasinė pirtis prieblandoje"
        className="absolute inset-0 w-full h-full object-cover opacity-90"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/55" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-transparent to-transparent" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 pt-[140px] md:pt-[180px]">
        <div className="flex items-center gap-4 text-[#f9f8f6]/80">
          <span className="w-10 h-px bg-[#f9f8f6]/60" />
          <span className="text-[11px] uppercase tracking-[0.32em]">
            {labelLine}
          </span>
        </div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 mt-12 md:mt-20">
        <h1
          data-testid="hero-headline"
          className="font-serif-display text-[#f9f8f6] text-[42px] sm:text-6xl md:text-7xl lg:text-[92px] leading-[1.04] tracking-tight font-light max-w-[18ch]"
        >
          {hero.headlineTop || "Mažoji architektūra"}
          <br />
          <span className="italic font-light text-[#e9dfd2]">
            {hero.headlineBottom || "gyvenimui ir poilsiui."}
          </span>
        </h1>

        <p
          data-testid="hero-subheadline"
          className="mt-10 max-w-2xl text-[#f9f8f6]/85 text-base md:text-lg leading-relaxed font-light"
        >
          {site.philosophyShort}
        </p>

        <div className="mt-12 md:mt-16 flex flex-col sm:flex-row gap-4">
          <Link to={ctaP.to} data-testid="hero-cta-projects" className="btn-light">
            {ctaP.label} <ArrowRight size={16} strokeWidth={1.5} />
          </Link>
          <Link to={ctaS.to} data-testid="hero-cta-contact" className="btn-ghost-light">
            {ctaS.label}
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-0 right-0 z-10 px-6 md:px-12 lg:px-20">
        <div className="max-w-[1400px] mx-auto flex items-end justify-between text-[#f9f8f6]/75">
          <div className="hidden md:block max-w-md text-xs leading-relaxed font-light italic">
            „{site.authorQuote}“
          </div>
          <div className="text-[10px] uppercase tracking-[0.32em]">
            Slinkti ↓
          </div>
        </div>
      </div>
    </section>
  );
}
